module.exports = __webpack_public_path__ + "static/media/FrutosSilvestres_250.a5703594.jpg";